import type { EventFormat } from "@nifgash/shared/types";

// City / format / interest / language labels live in the i18n locale files
// now (t(`labels.<kind>.<value>`)); only the emoji map is still imported
// directly, since emoji are language-independent.
export const formatIcon: Record<EventFormat, string> = {
  cafe: "☕",
  run: "🏃",
  boardgames: "🎲",
  movie: "🎬",
  walk: "🚶",
  sport: "⚽",
  music: "🎵",
  food: "🍽️",
  drinks: "🍻",
  beach: "🏖️",
  lecture: "🎓",
  party: "🎉",
  art: "🎨",
  nature: "🌳",
  other: "✨",
};
